"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApiImageRepo = createApiImageRepo;
const HTTPClient_1 = require("../../../common/api/HTTPClient");
const getApiUrl_1 = require("../../../common/api/utils/getApiUrl");
function createApiImageRepo() {
    return {
        uploadImage,
    };
}
async function uploadImage(file) {
    if (!(file instanceof File)) {
        throw new Error('The provided file is not a valid File instance');
    }
    const validFile = new File([file], file.name, { type: file.type });
    const formData = new FormData();
    formData.append('file', validFile);
    return await HTTPClient_1.HTTPClient.post({
        url: (0, getApiUrl_1.getApiUrl)(`/v1/images`),
        body: formData,
        type: 'form',
    });
}
